import React from 'react';
import Icon from '../../../components/AppIcon';

const AssignedUsersList = ({ assignedUsers, loading, badgeTitle }) => {
  if (loading) {
    return (
      <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-8">
        <div className="flex items-center space-x-3 mb-6">
          <Icon name="Users" size={24} className="text-blue-300" />
          <h3 className="text-xl font-heading font-semibold text-white">
            Users Who Earned This Badge
          </h3>
        </div>
        <div className="space-y-4">
          {[1, 2, 3, 4]?.map((index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full animate-pulse"></div>
                <div>
                  <div className="h-4 bg-white bg-opacity-20 rounded w-32 mb-1 animate-pulse"></div>
                  <div className="h-3 bg-white bg-opacity-10 rounded w-24 animate-pulse"></div>
                </div>
              </div>
              <div className="h-4 bg-white bg-opacity-10 rounded w-20 animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="Users" size={24} className="text-blue-300" />
          <h3 className="text-xl font-heading font-semibold text-white">
            Users Who Earned This Badge
          </h3>
        </div>
        <span className="px-3 py-1 bg-blue-500 bg-opacity-20 text-blue-300 rounded-lg font-caption text-sm">
          {assignedUsers?.length || 0} users
        </span>
      </div>
      {!assignedUsers || assignedUsers?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Users" size={48} className="mx-auto text-blue-300 mb-4 opacity-50" />
          <p className="text-blue-200 text-lg mb-2">
            No users have earned this badge yet
          </p>
          <p className="text-blue-300 text-sm">
            This badge hasn't been assigned to any users yet.
          </p>
        </div>
      ) : (
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {assignedUsers?.map((userBadge) => (
            <div
              key={userBadge?.id}
              className="flex items-center justify-between p-4 bg-white bg-opacity-5 rounded-xl hover:bg-opacity-10 transition-all duration-200"
            >
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-500 bg-opacity-20 rounded-full flex items-center justify-center">
                  <Icon name="User" size={20} className="text-blue-300" />
                </div>
                <div>
                  <p className="text-white font-medium">
                    {userBadge?.user_profiles?.display_name || userBadge?.user_profiles?.email || 'Unknown User'}
                  </p>
                  <p className="text-blue-200 text-sm">
                    {userBadge?.user_profiles?.email}
                  </p>
                </div>
              </div>

              <div className="text-right">
                <p className="text-green-300 text-sm font-medium">
                  Earned {new Date(userBadge.earned_at || userBadge.created_at)?.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </p>
                <div className="flex items-center justify-end space-x-2 mt-1">
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                  <span className="text-blue-200 text-xs">
                    {userBadge?.status === 'earned' ? 'Completed' : userBadge?.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AssignedUsersList;